// Script para crear SOLO las categorías correctas con nombres exactos
export {};

(window as any).createExactCategories = async function() {
  console.log('🚀 Creando SOLO las categorías correctas con nombres exactos...');
  
  try {
    // Verificar que Firebase esté disponible
    if (!(window as any).auth) {
      throw new Error('Firebase no está disponible');
    }
    
    const { db, collection, doc, setDoc, serverTimestamp } = (window as any).auth;
    
    // Obtener el ID del usuario actual
    const userId = (window as any).auth.auth.currentUser?.uid;
    if (!userId) {
      throw new Error('Usuario no autenticado');
    }

    console.log(`👤 Usuario: ${userId}`);

    // SOLO las categorías correctas con nombres exactos
    const exactCategories = {
      'REMERA': {
        name: 'REMERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Manga corta', 'Manga larga', 'Musculosa', 'Crop Top', 'Polo', 'Térmica'],
            required: true
          },
          cuello: {
            type: 'select',
            options: ['Redondo', 'En V', 'Polo', 'Escote Bote', 'Cuello alto'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Urbano', 'Deportivo', 'Básico', 'Oversize'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'CAMPERA': {
        name: 'CAMPERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Abrigo grueso', 'Deportiva', 'Rompeviento', 'Jean', 'Cuero', 'Inflable', 'Bomber', 'Parka', 'Impermeable'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Algodón', 'Poliéster', 'Cuero', 'Eco-Cuero', 'Denim', 'Nylon', 'Lana', 'Softshell', 'Gabardina'],
            required: true
          },
          tipoCierre: {
            type: 'select',
            options: ['Cierre', 'Abotonado'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Urbano', 'Deportivo', 'Formal', 'Outdoor'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'SOMBRERO, GORRA, GORRO': {
        name: 'SOMBRERO, GORRA, GORRO',
        fields: {
          talle: {
            type: 'select',
            options: ['Único', 'Ajustable', 'XS', 'S', 'M', 'L', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '56', '57', '58', '59', '60'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Gorro', 'Visera', 'Bucket Hat', 'Beanie', 'Boina', 'Fedora', 'Visera Plana', 'Trucker'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Lana', 'Algodón', 'Poliéster', 'Paja', 'Acrílico', 'Mezcla'],
            required: true
          },
          ajuste: {
            type: 'select',
            options: ['Elástico', 'Correa', 'Velcro', 'Sin ajuste'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Urbano', 'Casual', 'Deportivo', 'Elegante'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'PANTALÓN': {
        name: 'PANTALÓN',
        fields: {
          talle: {
            type: 'select',
            options: ['26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'Único'],
            multiple: true,
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Jean', 'Jogger', 'Babucha', 'Sastrero', 'Deportivo', 'Cargo', 'Chupín', 'Oxford', 'Recto', 'Acampanado'],
            required: true
          },
          corte: {
            type: 'select',
            options: ['Regular Fit', 'Slim Fit', 'Wide Leg', 'Recto', 'Chupín', 'Flare'],
            required: true
          },
          tiro: {
            type: 'select',
            options: ['Alto', 'Medio', 'Bajo'],
            required: true
          },
          largo: {
            type: 'select',
            options: ['Largo', 'Corto', 'Short', 'Bermuda', '7/8', '3/4'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Denim', 'Algodón', 'Gabardina', 'Poliéster', 'Lino', 'Frisa', 'Elastano'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Formal', 'Urbano', 'Deportivo'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'CAMISA': {
        name: 'CAMISA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', 'Único'],
            multiple: true,
            required: true
          },
          manga: {
            type: 'select',
            options: ['Larga', 'Corta'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Formal', 'Casual', 'Lino', 'Jean', 'Vestir', 'Hawaiana', 'Oversize', 'Urbano', 'Vintage'],
            multiple: true,
            required: true
          },
          material: {
            type: 'select',
            options: ['Algodón', 'Lino', 'Poliéster', 'Viscosa', 'Jean', 'Mezcla'],
            required: true
          },
          corte: {
            type: 'select',
            options: ['Regular Fit', 'Slim Fit', 'Oversize'],
            required: true
          }
        },
        enabled: true
      },
      
      'POLLERA': {
        name: 'POLLERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', 'Único'],
            multiple: true,
            required: true
          },
          largo: {
            type: 'select',
            options: ['Mini', 'Midi', 'Larga', 'Tobillera'],
            required: true
          },
          material: {
            type: 'select',
            options: ['Algodón', 'Denim', 'Lino', 'Poliéster', 'Viscosa', 'Satén'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Tubo', 'Evasé', 'Plisada', 'Mini', 'Midi', 'Larga', 'Cruzada', 'Denim', 'Casual', 'Formal', 'Elegante', 'Urbano'],
            multiple: true,
            required: true
          },
          genero: {
            type: 'select',
            options: ['Mujer', 'Niñas'],
            required: true
          },
          cintura: {
            type: 'select',
            options: ['Alta', 'Media', 'Baja'],
            required: true
          }
        },
        enabled: true
      },
      
      'VESTIDO': {
        name: 'VESTIDO',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'Único', '2', '4', '6', '8', '10', '12', '14', '16', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50'],
            multiple: true,
            required: true
          },
          material: {
            type: 'select',
            options: ['Algodón', 'Lino', 'Seda', 'Encaje', 'Tul', 'Lana', 'Jean', 'Denim', 'Cuero ecológico', 'Poliéster', 'Viscosa', 'Elastano', 'Lycra'],
            required: true
          },
          largo: {
            type: 'select',
            options: ['Mini', 'Midi', 'Largo', 'Maxi', 'Corto asimétrico', 'Largo asimétrico'],
            required: true
          },
          corte: {
            type: 'select',
            options: ['Redondo', 'En V', 'Strapless', 'Asimétrico', 'Alto', 'Bote', 'Cruzado'],
            required: true
          },
          mangas: {
            type: 'select',
            options: ['Sin mangas', 'Tirantes finos', 'Corta', '3/4', 'Larga', 'Abullonada', 'Con volados', 'Globo', 'Caída', 'Off-shoulder', 'Acampanada', 'Mariposa'],
            required: true
          },
          diseño: {
            type: 'select',
            options: ['Liso', 'Floral', 'Rayado', 'Lunares', 'Cuadrillé', 'Abstracto', 'Con bordado', 'Tie-dye'],
            required: true
          },
          estilo: {
            type: 'select',
            options: ['Casual', 'Elegante', 'Formal', 'De fiesta', 'Coctel', 'Urbano', 'Vintage', 'Playero'],
            multiple: true,
            required: true
          }
        },
        enabled: true
      },
      
      'PAÑUELO': {
        name: 'PAÑUELO',
        fields: {
          tamaño: {
            type: 'number',
            unit: 'cm',
            required: true
          },
          material: {
            type: 'select',
            options: ['Seda', 'Poliéster', 'Algodón', 'Lino', 'Satén', 'Viscosa'],
            required: true
          },
          diseño: {
            type: 'select',
            options: ['Liso', 'Floral', 'Geométrico', 'Animal Print', 'Rayado', 'Abstracto'],
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Cuello', 'Cabeza', 'Decorativo', 'Pulsera', 'Bolso', 'Cinturón'],
            multiple: true,
            required: true
          },
          forma: {
            type: 'select',
            options: ['Cuadrado', 'Rectangular', 'Triangular'],
            required: true
          }
        },
        enabled: true
      },
      
      'CALZADO': {
        name: 'CALZADO',
        fields: {
          talle: {
            type: 'select',
            options: ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', 'Único'],
            required: true
          },
          tipo: {
            type: 'select',
            options: ['Urbano', 'Deportivo', 'Bota', 'Botín', 'Sandalia', 'Alpargata', 'Formal', 'Mocasín', 'Taco', 'Ojota'],
            multiple: true,
            required: true
          },
          exterior: {
            type: 'select',
            options: ['Cuero', 'Eco-Cuero', 'Lona', 'Malla', 'Gamuza', 'Sintético'],
            required: true
          },
          interior: {
            type: 'select',
            options: ['Tela', 'Cuero', 'Mesh', 'Sintético'],
            required: true
          },
          suela: {
            type: 'select',
            options: ['Goma', 'EVA', 'Caucho', 'Cuero', 'Sintética'],
            required: true
          },
          altura: {
            type: 'number',
            unit: 'cm',
            required: false
          },
          cierre: {
            type: 'select',
            options: ['Cordones', 'Cierre', 'Velcro', 'Sin cierre', 'Elástico'],
            required: true
          }
        },
        enabled: true
      }
    };

    // Campos globales para todos los productos
    const globalFields = {
      sku: {
        type: 'text',
        generated: true,
        required: true
      },
      stock: {
        type: 'number',
        format: 'thousands',
        required: true
      },
      precioCompra: {
        type: 'currency',
        symbol: '$',
        format: 'thousands',
        required: true
      },
      precioVenta: {
        type: 'currency',
        symbol: '$',
        format: 'thousands',
        required: true
      },
      fechaIngreso: {
        type: 'date',
        format: 'DD/MM/AA',
        required: true
      },
      marca: {
        type: 'select',
        searchable: true,
        required: true
      },
      proveedor: {
        type: 'select',
        searchable: true,
        required: true
      },
      genero: {
        type: 'select',
        options: ['Hombre', 'Mujer', 'Niños', 'Niñas', 'Unisex'],
        multiple: true,
        required: true
      },
      temporada: {
        type: 'select',
        options: ['Verano', 'Otoño', 'Invierno', 'Primavera', 'Atemporal'],
        required: true
      }
    };

    console.log('📂 Creando SOLO las categorías correctas...');

    // Crear cada categoría con nombre exacto
    for (const [categoryName, categoryData] of Object.entries(exactCategories)) {
      console.log(`📂 Creando: ${categoryName}`);
      
      // Agregar campos globales
      const completeCategoryData = {
        ...categoryData,
        fields: {
          ...categoryData.fields,
          ...globalFields
        },
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      
      // Crear documento con nombre exacto como ID
      const categoryRef = doc(db, 'users', userId, 'categories', categoryName);
      await setDoc(categoryRef, completeCategoryData);
      
      console.log(`✅ "${categoryName}" creada`);
    }
    
    console.log('🎉 SOLO las categorías correctas creadas');
    console.log('📋 Categorías creadas:');
    Object.keys(exactCategories).forEach(name => {
      console.log(`   - ${name}`);
    });
    
    return {
      success: true,
      message: 'SOLO las categorías correctas creadas',
      categories: Object.keys(exactCategories)
    };
    
  } catch (error) {
    console.error('❌ Error:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : error
    };
  }
};

console.log('🔧 Script de categorías exactas cargado');
console.log('💡 Usa: window.createExactCategories()');
